import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

const partners = [
    {
        name: 'Digital Badge Academy',
        icon: 'bi-mortarboard-fill',
        website: 'https://www.digitalbadgeacademy.com',
        description: 'Leaders in digital badge programme design and implementation.',
        services: ['Microlearning', 'Mobile learning', 'Badge programme design'],
    },
    {
        name: 'ProMobile BI',
        icon: 'bi-graph-up-arrow',
        website: '#',
        description: 'Experts in credentialing programme strategy and data analytics.',
        services: ['Programme Design', 'Development', 'Implementation', 'Programme Evaluation', 'Data Analysis', 'Project Management', 'Gamification'],
    },
];

export default function PartnersPage() {
    return (
        <>
            <Box sx={{ bgcolor: 'primary.main', color: 'white', py: 10, textAlign: 'center' }}>
                <Container maxWidth="md">
                    <Typography variant="h3" fontWeight={700} gutterBottom>Partners</Typography>
                    <Typography variant="h6" sx={{ opacity: 0.85 }}>
                        Connect with leaders in micro-credentialing who can help you build a successful badge programme.
                    </Typography>
                </Container>
            </Box>

            <Box component="section" sx={{ py: 8 }}>
                <Container maxWidth="lg">
                    <Box sx={{ maxWidth: 600, mx: 'auto', textAlign: 'center', mb: 6 }}>
                        <Typography variant="h4" fontWeight={700} gutterBottom>Need Help Getting Started?</Typography>
                        <Typography color="text.secondary">
                            Our partners are completely independent from TC Everywhere, but we think they're great and highly recommend them.
                        </Typography>
                    </Box>

                    <Grid container spacing={4} justifyContent="center">
                        {partners.map((partner) => (
                            <Grid item xs={12} md={6} lg={5} key={partner.name}>
                                <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <CardContent sx={{ p: 4, flexGrow: 1 }}>
                                        <Box display="flex" alignItems="center" gap={2} mb={2}>
                                            <Box sx={{ bgcolor: 'primary.main', color: 'white', borderRadius: '50%', p: 1.5, display: 'flex' }}>
                                                <Box component="i" className={`bi ${partner.icon}`} sx={{ fontSize: '1.25rem' }} />
                                            </Box>
                                            <Typography variant="h5" fontWeight={700}>{partner.name}</Typography>
                                        </Box>
                                        <Typography color="text.secondary" paragraph>{partner.description}</Typography>
                                        <Typography variant="subtitle2" fontWeight={600} gutterBottom>Services offered:</Typography>
                                        {partner.services.map(s => (
                                            <Box key={s} display="flex" alignItems="center" gap={1} mb={0.5}>
                                                <Box component="i" className="bi bi-check-circle-fill" sx={{ color: 'success.main', fontSize: '0.875rem', flexShrink: 0 }} />
                                                <Typography variant="body2" color="text.secondary">{s}</Typography>
                                            </Box>
                                        ))}
                                    </CardContent>
                                    <CardActions sx={{ px: 4, pb: 3 }}>
                                        <Button
                                            variant="outlined"
                                            fullWidth
                                            href={partner.website}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            component="a"
                                        >
                                            Find Out More
                                        </Button>
                                    </CardActions>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>

            <Box component="section" sx={{ py: 8, bgcolor: 'background.paper', textAlign: 'center' }}>
                <Container maxWidth="md">
                    <Typography variant="h5" fontWeight={700} gutterBottom>Interested in becoming a partner?</Typography>
                    <Typography color="text.secondary" mb={3}>
                        If you offer services that complement digital credentialing and would like to be listed here, we'd love to hear from you.
                    </Typography>
                    <Button component={Link} to="/contact" variant="contained" size="large">Get In Touch</Button>
                </Container>
            </Box>
        </>
    );
}
